import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { TutorContext } from "../context/TutorContext";

export default function TutorProtectedRoute() {
  const { isLoggedIn, loading } = useContext(TutorContext);

  if (loading) return null; // or a spinner

  if (!isLoggedIn) {
    return <Navigate to="/tutor/login" replace />;
  }

  return <Outlet />;
}